export default {
  listaLogs: [],
  logSelecionado: null,
  order: '',
  direcao: '',
  estaCarregando: false,
  paginaAtual: 1,
  totalItens: null,
  todosItensCarregados: false,
  objLog: {
    data: '',
    info_evento: '',
    usuario: {
      id: '',
      nome: '',
      email: '',
      senha: '',
      data_criacao: '',
      ativo: ''
    }
  }
}
